import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'provide_list_health_safety_trainings_offered_new_production'

export const dataPointDefinition = {
  retracedId: 'provide_list_health_safety_trainings_offered_new_production',
  name: 'Please provide a list of all health and safety trainings offered to NEW production workers in the facility',
  description: '',
  meta: {
    slcpMeta: {
      key: 'ms-do-19f',
      number: 'MS-DO-27.2',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'follow-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[2],ms-5--7-14x',
      machineShowHide: '[2],ms-5--7-14x',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-do-19f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 33640,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
